//Author June Leow
//Date Feb 28th, 2025
import { getReducer, getSetStateFunction } from '../../../../util/util';
import { Col, Row, Offcanvas, OffcanvasBody, Collapse} from 'reactstrap';
import React, {useReducer, useEffect, useState} from 'react';
import {NavLink} from 'react-router-dom';

//initialize the state
const initialState = {
  panelOpen: false,
  isOpen: {},
  allExpanded: true
};

//reducer function that perform state update
const reducer = getReducer();

const FloatingTab = (props) => {
  const controller = new AbortController();
  const [state, dispatch] = useReducer(reducer, initialState);
  const setState = getSetStateFunction(dispatch);
  const [currentSection, setCurrentSection] = useState('');

  useEffect(() => {
    initializeExpandedState();
    const hash = window.location.hash;
    if (hash) {
      setCurrentSection(hash.substring(1));
    }

    const handleScroll = () => {
      const sections = document.querySelectorAll('[id^="building-"], [id^="unit-"], [id^="level-"], [id^="room-"]');
      let currentSectionId = '';
      
      sections.forEach(section => {
        const rect = section.getBoundingClientRect();
        if (rect.top <= 150 && rect.bottom >= 150) {
          currentSectionId = section.id;
        }
      });

      if (currentSectionId) {
        setCurrentSection(currentSectionId);
      }
    };

    const handleHashChange = () => {
      const hash = window.location.hash;
      if (hash) {
        setCurrentSection(hash.substring(1));
      }
    };

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('hashchange', handleHashChange);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('hashchange', handleHashChange);
      controller.abort();
    };
  }, []);

  const initializeExpandedState = () => {
    const newIsOpen = {};
    props.upd.property.buildings.forEach((building, index) => {
      newIsOpen[`building${index}`] = true;
      building.units.forEach((unit, index2) => {
        newIsOpen[`building${index}unit${index2}`] = true;
        unit.levels.forEach((level, index3) => {
          newIsOpen[`building${index}unit${index2}level${index3}`] = true;
          level.rooms.forEach((room, index4) => {
            newIsOpen[`building${index}unit${index2}level${index3}room${index4}`] = true;
          });
        });
      });
    });
    setState({ isOpen: newIsOpen, allExpanded: true });
  };

  const toggleAll = () => {
    const newIsOpen = {};
    const newExpandState = !state.allExpanded;
    
    props.upd.property.buildings.forEach((building, index) => {
      newIsOpen[`building${index}`] = newExpandState;
      building.units.forEach((unit, index2) => {
        newIsOpen[`building${index}unit${index2}`] = newExpandState;
        unit.levels.forEach((level, index3) => {
          newIsOpen[`building${index}unit${index2}level${index3}`] = newExpandState;
          level.rooms.forEach((room, index4) => {
            newIsOpen[`building${index}unit${index2}level${index3}room${index4}`] = newExpandState;
          });
        });
      });
    });
    
    setState({ isOpen: newIsOpen, allExpanded: newExpandState });
  };

  const toggleShow = () => {
    setState({panelOpen: !state.panelOpen});
  }

  const toggleNode = (path) => {
    let isOpen = { ...state.isOpen };
    isOpen[path] = !isOpen[path];
    setState({ isOpen });
  };

  const addBuilding = ()=>{
    let newUPD = Object.assign({}, props.upd);
    let buildings = newUPD.property.buildings.slice();
    buildings.push({imageStructureFront:[], imageStructureRear:[], imageStructureLeft:[], imageStructureRight:[],imageBuildingFront:[], imageBuildingRear:[], imageBuildingLeft:[], imageBuildingRight:[],imageDwellingFront:[], imageDwellingRear:[], imageDwellingLeft:[], imageDwellingRight:[], condoCarStorages:[],exteriorDeficiencies:[],exteriorUpdates:[], units:[{imageFloorPlan:[], unitView:{views:[]}, featureTypes:[], heatingSystems:[], coolingSystems:[], mechanicalDeficiencies:[], mechanicalUpdates:[], garages:[], levels:[{gla:[], belowGradeExits:[], atticAccess:[], rooms:[{roomType:'', imageRoom:[], imageLivingroom:[], imageKitchen:[], imageBathroom:[], imageOven:[], appliances:{},interiorUpdates:[], interiorDeficiencies:[], plumbingFixtures:[], roomFeatures:[{roomFeatureType:[]}]}]}]}]});

    newUPD.property.buildings = buildings;
    props.update(newUPD);
  }

  const addUnit = (index)=>{
    let newUPD = Object.assign({}, props.upd);
    let units = newUPD.property.buildings[index].units?newUPD.property.buildings[index].units.slice():[];
    units.push({imageFloorPlan:[], unitView:{views:[]}, unitFeatures:[], heatingSystems:[], coolingSystems:[], mechanicalDeficiencies:[], mechanicalUpdates:[], garages:[], levels:[{gla:[], belowGradeExits:[], atticAccess:[], rooms:[{appliances:{},interiorUpdates:[], interiorDeficiencies:[], plumbingFixtures:[], roomFeatures:[{roomFeatureType:[]}]}]}]});
    newUPD.property.buildings[index].units = units;
    props.update(newUPD);
  }

  const addLevel = (index, index2)=>{
    let newUPD = Object.assign({}, props.upd);
    let levels = newUPD.property.buildings[index].units[index2].levels?newUPD.property.buildings[index].units[index2].levels.slice():null;
    levels.push({gla:[], belowGradeExits:[], atticAccess:[], rooms:[{imageRoom:[], imageLivingroom:[], imageKitchen:[], imageBathroom:[], imageOven:[], appliances:{},interiorUpdates:[], interiorDeficiencies:[], plumbingFixtures:[], roomFeatures:[{roomFeatureType:[]}]}]});
    newUPD.property.buildings[index].units[index2].levels = levels;
    props.update(newUPD);
  }

  const addRoom = (index, index2, index3) => {
    let newUPD = Object.assign({}, props.upd);
    let rooms = newUPD.property.buildings[index].units[index2].levels[index3].rooms ? newUPD.property.buildings[index].units[index2].levels[index3].rooms.slice() : [];
    rooms.push({imageRoom: [], imageLivingroom: [], imageKitchen: [], imageBathroom: [], imageOven: [], appliances: {},interiorUpdates: [], interiorDeficiencies: [], plumbingFixtures: [], roomFeatures: [{roomFeatureType: []}]});
    newUPD.property.buildings[index].units[index2].levels[index3].rooms = rooms;
    props.update(newUPD);
  };

  const isCurrentSection = (sectionId) => {
    return currentSection === sectionId;
  };

  //API call
  

  //render
  return <div>
    {!state.panelOpen ? (
      <div className="floating-upd-container cursor-pointer" onClick={toggleShow}>
        <center className="flashit">SHOW QUICK NAVIGATION</center>
      </div>
    ) : null}
    <Offcanvas isOpen={state.panelOpen} backdrop={false} direction="end" className="floating-upd" style={{ padding: '0px' }}>
      <OffcanvasBody style={{ padding: '0px', paddingBottom: '20px', paddingLeft: '20px' }}>
        <div className="floating-upd-nav-bar cursor-pointer" onClick={toggleShow}>
          <center>HIDE QUICK NAVIGATION</center>
        </div>
        <div className="floating-upd-content">
          <div className="tree-header">
            <div className="my-well cursor-pointer" style={{padding:'5px', color: '#86bdef'}} onClick={props.save}>
              <center>
                <i className="fa fa-floppy-disk" style={{fontSize:'18px'}} />Save
              </center>
            </div>
            <Row>
              <Col sm="6">
                <div style={{paddingLeft: '10px'}}>
                  <NavLink to="#" onClick={toggleAll} style={{fontSize:'12px', color: '#86bdef'}}>
                    <i className={`fa ${state.allExpanded ? 'fa-compress' : 'fa-expand'}`} style={{marginRight: '5px'}}/>
                    {state.allExpanded ? 'Collapse All' : 'Expand All'}
                  </NavLink>
                </div> 
              </Col>
              <Col sm="6">
                {!props.disabled && (
                <div className="upd-align-right" style={{margin: '0px', paddingRight: '10px'}}>
                  <NavLink to="#" onClick={addBuilding} style={{fontSize:'12px', color: '#86bdef'}}>
                    <i className="fa fa-plus green-color" style={{marginRight: '5px'}}/>
                    Add Building
                  </NavLink>
                </div>
              )}
              </Col>
            </Row>
            
          </div>
          
          <ul className="tree">
            {props.upd.property.buildings.map((building, index) => {
              const buildingPath = `building${index}`;
              const buildingId = `building-${index}`;
              return (
                <li key={index}>
                  <div className="tree-node">
                    <div 
                      className={`tree_item ${state.isOpen[buildingPath] ? 'expanded' : ''} ${isCurrentSection(buildingId) ? 'current-section' : ''}`}
                    >
                      <div onClick={() => toggleNode(buildingPath)} style={{display: 'inline-block'}}>
                        <i className={`fa-solid ${state.isOpen[buildingPath] ? 'fa-minus' : 'fa-plus'} toggle-icon`}></i>
                      </div>
                      <a href={`#${buildingId}`} style={{color: 'inherit', textDecoration: 'none'}}>
                        <i className="fa-solid fa-building"></i>
                        <span>Building #{index + 1}</span>
                      </a>
                    </div>
                    {!props.disabled && 
                      <div className="add-button">
                        <NavLink to="#" onClick={() => addUnit(index)} style={{fontSize:'12px'}}>
                          <i className="fa fa-plus green-color"/>Add Unit
                        </NavLink>
                      </div>
                    }
                  </div>
                  <ul className={state.isOpen[buildingPath] ? 'show' : ''}>
                    {building.units.map((unit, index2) => {
                      const unitPath = `building${index}unit${index2}`;
                      const unitId = `unit-${index}-${index2}`;
                      return (
                        <li key={index2}>
                          <div className="tree-node">
                            <div 
                              className={`tree_item ${state.isOpen[unitPath] ? 'expanded' : ''} ${isCurrentSection(unitId) ? 'current-section' : ''}`}
                            >
                              <div onClick={() => toggleNode(unitPath)} style={{display: 'inline-block'}}>
                                <i className={`fa-solid ${state.isOpen[unitPath] ? 'fa-minus' : 'fa-plus'} toggle-icon`}></i>
                              </div>
                              <a href={`#${unitId}`} style={{color: 'inherit', textDecoration: 'none'}}>
                                <i className="fa-regular fa-building-un"></i>
                                <span>Unit #{index2 + 1}</span>
                              </a>
                            </div>
                            {!props.disabled && 
                              <div className="add-button">
                                <NavLink to="#" onClick={() => addLevel(index, index2)} style={{fontSize:'12px'}}>
                                  <i className="fa fa-plus green-color"/>Add Level
                                </NavLink>
                              </div>
                            }
                          </div>
                          <ul className={state.isOpen[unitPath] ? 'show' : ''}>
                            {unit.levels.map((level, index3) => {
                              const levelPath = `building${index}unit${index2}level${index3}`;
                              const levelId = `level-${index}-${index2}-${index3}`;
                              return (
                                <li key={index3}>
                                  <div className="tree-node">
                                    <div 
                                      className={`tree_item ${state.isOpen[levelPath] ? 'expanded' : ''} ${isCurrentSection(levelId) ? 'current-section' : ''}`}
                                    >
                                      <div onClick={() => toggleNode(levelPath)} style={{display: 'inline-block'}}>
                                        <i className={`fa-solid ${state.isOpen[levelPath] ? 'fa-minus' : 'fa-plus'} toggle-icon`}></i>
                                      </div>
                                      <a href={`#${levelId}`} style={{color: 'inherit', textDecoration: 'none'}}>
                                        <i className="fa-duotone fa-regular fa-stairs"></i>
                                        <span>Level #{index3 + 1}</span>
                                      </a>
                                    </div>
                                    {!props.disabled && 
                                      <div className="add-button">
                                        <NavLink 
                                          to="#" 
                                          onClick={(e) => {
                                            e.preventDefault();
                                            addRoom(index, index2, index3);
                                          }} 
                                          style={{fontSize:'12px'}}
                                        >
                                          <i className="fa fa-plus green-color"/>Add Room
                                        </NavLink>
                                      </div>
                                    }
                                  </div>
                                  <ul className={state.isOpen[levelPath] ? 'show' : ''}>
                                    {level.rooms.map((room, index4) => {
                                      const roomId = `room-${index}-${index2}-${index3}-${index4}`;

                                      let roomDisplayName = `Room #${index4 + 1}`;
                                      if(room.roomType){
                                        roomDisplayName = 
                                          room.roomType === 'OTHER ROOM' && room.otherRoomTypeDescription ? room.otherRoomTypeDescription : room.roomType.charAt(0).toUpperCase() + room.roomType.slice(1).toLowerCase().replace('_', ' ');
                                      }
                                      return (
                                        <li key={index4}>
                                          <div 
                                            className={`tree_item ${isCurrentSection(roomId) ? 'current-section' : ''}`}
                                          >
                                            <a href={`#${roomId}`} style={{color: 'inherit', textDecoration: 'none'}}>
                                              <i className="fa-solid fa-booth-curtain"></i>
                                              <span>{roomDisplayName}</span>
                                            </a>
                                          </div>
                                        </li>
                                      );
                                    })}
                                  </ul>
                                </li>
                              );
                            })}
                          </ul>
                        </li>
                      );
                    })}
                  </ul>
                </li>
              );
            })}
          </ul>
        </div>
      </OffcanvasBody>
    </Offcanvas>
  </div>;
}


export default FloatingTab;
